import {
  animate,
  state,
  style,
  transition,
  trigger,
} from '@angular/animations';

import {
  Component,
  TemplateRef,
  ViewChild,
  ChangeDetectionStrategy,
} from '@angular/core';

@Component({
  selector: 'gax-error',
  imports: [],
  templateUrl: './error.component.html',
  styleUrls: ['./error.component.scss'],
  animations: [
    trigger('fadeIn', [
      state('void', style({ opacity: 0 })),
      state('*', style({ opacity: 1 })),
      transition(':enter', [animate('300ms linear')]),
    ]),
  ],
})
export class ErrorComponent {
  @ViewChild(TemplateRef, { static: true })
  template!: TemplateRef<unknown>;
}
